import React, { FC, useContext, useEffect, useState } from 'react';

import classNames from 'classnames';

import { Checkbox } from '@shared/ui';

import cls from './BodyComponents.module.css';
import { DateInput } from '../../../../../components/DateInput/DateInput';
import { FormBlock } from '../../../../../components/UI/Form/FormBlock/FormBlock';
import { Select } from '../../../../../components/UI/Select/Select';
import { Input } from '../../../../../components/UI/TextInput/Input';
import { ModalAddContext } from '../ModalAdd';

export const EmployeeBlock = () => {
    const {
        currentList,
        isActiveCheckbox,
        onCheckboxChange,
        formState,
        formHandler,
        onCurrencyChange,
        selectedCurrency,
        employeelList,
        selectedEmployee,
        onEmployeeChange,
        onDateChange,
        errors,
        sumFormHandler,
    } = useContext(ModalAddContext);
    const { account_number, opening_balance_value, title } = formState;

    useEffect(() => {
        const initialState = {
            title: null,
            accountStartBalance: null,
            currency: null,
            employee: null,
        };
        if (errors.employee) {
            errors.employee.forEach((error) => {
                initialState[error.name] = error.messages.toString();
            });
        }
        setErrorsTab(initialState);
    }, [errors.employee]);

    const [errorsTab, setErrorsTab] = useState({
        title: null,
        accountStartBalance: null,
        currency: null,
        employee: null,
    });
    return (
        <div className={classNames(cls.formBlock)}>
            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Select
                        isSmartPosition
                        selected={selectedEmployee || null}
                        onChange={onEmployeeChange}
                        placeholder={i18next.t(
                            'EmployeeBlock.return.Select.selectedEmployee.placeholder'
                        )}
                        title={i18next.t('EmployeeBlock.return.Select.selectedEmployee.title')}
                        isRequired
                        options={employeelList}
                        error={errorsTab.employee}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isRequired
                        title={i18next.t('EmployeeBlock.return.InputTitle.title')}
                        name="title"
                        value={title}
                        onChange={formHandler}
                        error={errorsTab.title}
                    />
                </div>
            </FormBlock>
            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isRequired={false}
                        title={i18next.t('EmployeeBlock.return.InputAccount_number.title')}
                        name="account_number"
                        value={account_number}
                        onChange={formHandler}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <Select
                        isSmartPosition
                        selected={selectedCurrency || null}
                        onChange={onCurrencyChange}
                        placeholder={i18next.t('EmployeeBlock.return.Select.placeholder')}
                        title={i18next.t('EmployeeBlock.return.Select.title')}
                        isRequired
                        options={currentList}
                        error={errorsTab.currency}
                    />
                </div>
            </FormBlock>
            <FormBlock>
                <div className={classNames(cls.blockWrapper)}>
                    <Input
                        isRequired
                        title={i18next.t('EmployeeBlock.return.InputOpening_balance_value.title')}
                        name="opening_balance_value"
                        value={opening_balance_value}
                        onChange={sumFormHandler}
                        error={errorsTab.accountStartBalance}
                    />
                </div>
                <div className={classNames(cls.blockWrapper)}>
                    <DateInput
                        title={i18next.t('EmployeeBlock.return.DateInput.title')}
                        isRequired={false}
                        date={formState.opening_balance_date}
                        inventoryGuid="inventoryGuid"
                        parameterName="opening_balance_date"
                        newCallback={onDateChange}
                        options={{
                            startDate: formState.opening_balance_date,
                            singleDatePicker: true,
                            showDropdowns: true,
                            autoApply: true,
                        }}
                    />
                </div>
            </FormBlock>
            <Checkbox
                title={i18next.t('EmployeeBlock.return.Checkbox.title')}
                isActive={isActiveCheckbox}
                onClick={onCheckboxChange}
                isDisabled={false}
            />
        </div>
    );
};
